import initial from "lodash/initial"
import isEqual from "lodash/isEqual"

export const contains = <T>(array: T[], element: T): boolean =>
  array.some((item) => isEqual(item, element))

export const intercalate = <T>(list: T[], separator: (index: number) => T) =>
  initial(list.flatMap((item, index) => [item, separator(index)]))
